import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router';
import {FormattedMessage} from 'react-intl';
import CommonMessages from '../../../intl/CommonMessages';
import {BankInfoShape} from '../../../utils/react/Shapes';
import Form from 'react-form-controlled';

class EditBankInfo extends React.Component {
  static propTypes = {
    initBankInfo: BankInfoShape.isRequired,
    saveHandler: PropTypes.func.isRequired,
    saveMessage: PropTypes.object,
    cancelHandler: PropTypes.func,
    cancelMessage: PropTypes.object,
    allowEditName: PropTypes.bool,
    allowCancel: PropTypes.bool
  };

  constructor(props) {
    super(props);
    const {id, name, key, url, contact, address} = this.props.initBankInfo;
    const {street, city, state, zip} = address;
    const {firstName, lastName, email, phone} = contact;
    this.state = {
      id,
      key,
      name,
      url,
      firstName,
      lastName,
      email,
      phone,
      street,
      city,
      state,
      zip
    };
  }

  disableSubmit = () => {
    return (!(this.state.street &&
    this.state.city &&
    this.state.state &&
    this.state.zip &&
    this.state.url));
  };

  onChangeHandler = state => {
    console.log('onChangeHandler', state);
    this.setState({
      ...state
    });
  };

  onSubmitHandler = state => {
    console.log('onSubmitHandler', state);
    this.props.saveHandler(state);
  };

  render() {
    const {
      saveMessage = CommonMessages.save,
      cancelMessage = CommonMessages.cancel,
      allowCancel = true,
      allowEditName = false
    } = this.props;

    const errorMessages = {};

    const nameField = allowEditName ? <div className='col-sm-9 '>
        <input
          type='text'
          className='form-control'
          name={'name'}
          id={'name'}
          placeholder='Your bank name'
        />
        {errorMessages['name']}
      </div> : <div className='col-sm-9 form-control-static'>
        {this.props.initBankInfo.name}
      </div>;

    const backLink = '/bank-info/view';

    return <Form
      value={this.state}
      onSubmit={this.onSubmitHandler}
      onChange={this.onChangeHandler}
      ref='form'
    >
      <div className='bank-info-section'>
        <h4>Basic</h4>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>Bank Name</label>
          {nameField}
        </div>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>Bank URL</label>
          <div className='col-sm-9 '>
            <input
              type='text'
              className='form-control'
              name={'url'}
              id={'url'}
              placeholder='An URL to your main site'
            />
            {errorMessages['url']}
          </div>
        </div>
      </div>
      <div className='bank-info-section'>
        <h4>Primary Contact</h4>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>First Name</label>
          <div className='col-sm-9 '>
            <input
              type='text'
              className='form-control'
              name={'firstName'}
              id={'firsName'}
              placeholder="Primary contact's first name"
            />
            {errorMessages['firstName']}
          </div>
        </div>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>Last Name</label>
          <div className='col-sm-9 '>
            <input
              type='text'
              className='form-control'
              name={'lastName'}
              id={'lastName'}
              placeholder="Primary contact's last name"
            />
            {errorMessages['lastName']}
          </div>
        </div>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>Email Address</label>
          <div className='col-sm-9 '>
            <input
              type='text'
              className='form-control'
              name={'email'}
              id={'email'}
              placeholder="Primary contact's email address"
            />
            {errorMessages['email']}
          </div>
        </div>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>Phone #</label>
          <div className='col-sm-9 '>
            <input
              type='text'
              className='form-control'
              name={'phone'}
              id={'phone'}
              placeholder="Primary contact's phone number"
            />
            {errorMessages['phone']}
          </div>
        </div>
      </div>
      <div className='bank-info-section'>
        <h4>Headquarters</h4>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>Street</label>
          <div className='col-sm-9 '>
            <input
              type='text'
              className='form-control'
              name={'street'}
              id={'street'}
              placeholder='Street Name'
            />
            {errorMessages['street']}
          </div>
        </div>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>City</label>
          <div className='col-sm-9 '>
            <input
              type='text'
              className='form-control'
              name={'city'}
              id={'city'}
              placeholder='City Name'
            />
            {errorMessages['city']}
          </div>
        </div>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>State</label>
          <div className='col-sm-9 '>
            <input
              type='text'
              className='form-control'
              name={'state'}
              id={'state'}
              placeholder='State'
            />
            {errorMessages['state']}
          </div>
        </div>
        <div className='form-group row'>
          <label className='col-sm-3 col-sm-offset-1 col-form-label'>Zip</label>
          <div className='col-sm-9 '>
            <input
              type='text'
              className='form-control'
              name={'zip'}
              id={'zip'}
              placeholder='Zip Code'
            />
            {errorMessages['zip']}
          </div>
        </div>
      </div>
      <div className='form-group row'>
        <div className='buttons'>
          {
            allowCancel ? <Link to={backLink} className='btn btn-link' onClick={ this.props.cancelHandler }>
                <FormattedMessage {...cancelMessage} />
              </Link> : null
          }
          <button className='btn btn-primary' disabled={this.disableSubmit()}>
            <FormattedMessage {...saveMessage} />
          </button>
        </div>
      </div>
    </Form>;
  }

}

export default EditBankInfo;



// WEBPACK FOOTER //
// ./src/apps/Bank/components/EditBankInfo.js